import React, { useState } from 'react';
import { Button, Divider, Skeleton, Typography } from '@mui/material';
import { ArrowBack, PrintOutlined } from '@mui/icons-material';

import styles from './PreviewStep.module.scss';
import messages from '../../messages.json';

export interface PreviewStepProps {
  stickerUrl?: string;
  onPrintClicked: () => void;
  onEditTermsClicked: () => void;
}

const PreviewStep: React.FC<PreviewStepProps> = ({
  stickerUrl,
  onPrintClicked,
  onEditTermsClicked,
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  return (
    <div>
      <div className={styles.headerContainer}>
        <Typography variant="h6">{messages.previewStep.header}</Typography>
        <div>
          <Button
            color="secondary"
            variant="text"
            size="small"
            startIcon={<ArrowBack />}
            sx={{ marginRight: '8px' }}
            onClick={onEditTermsClicked}
          >
            {messages.previewStep.editTerms}
          </Button>
          <Button
            color="secondary"
            variant="text"
            size="small"
            startIcon={<PrintOutlined />}
            onClick={onPrintClicked}
          >
            {messages.previewStep.printSticker}
          </Button>
        </div>
        <Divider />
      </div>
      <div>
        {!imageLoaded && (
          <Skeleton
            variant="rectangular"
            data-testid="skeleton"
            sx={{ height: '1000px' }}
          />
        )}
        {stickerUrl && (
          <img
            className={styles.stickerImage}
            onLoad={() => setImageLoaded(true)}
            src={stickerUrl}
            alt="Customers deal"
          />
        )}
      </div>
    </div>
  );
};

export default PreviewStep;
